//
// Spin Controller
//
// ----------------------------
spinController = {};
spinController.mainSpinConfig = {};

spinController.mainLandConfig = {};

spinController.mainLandOffsets = [0, 0, 0, 0, 0];

spinController.mainSpinTimeOffsets = [0, 0, 0, 0, 0];

spinController.startSpin = function (reelsToSpin) {
  spinController.mainSpinConfig = {};

  spinController.mainLandConfig = {};

  gameController.mainReelAnticipationSoundStarted = false;

  const allReels = [0, 1, 2, 3, 4];
  const reels = reelsToSpin ?? allReels;
  let reelsToHold = [];

  if (reelsToSpin) {
    reelsToHold = allReels.filter((reel) => !reelsToSpin.includes(reel));
  }

  for (let i = 0; i < 5; i++) {
    let shouldSpin = reels.find((element) => element === i);

    if (shouldSpin !== undefined) {
      shouldSpin = true;
    }

    const mainReelStartOffset = 0.15 * i;
    const mainReelSpinOffset = 0.15 * i;

    const mainReel = {
      type: "main",
      startDelay: 0.1,
      reelStartDelayOffset: mainReelStartOffset,
      pullbackAmount: 0.4,
      pullbackTime: 0.2,
      pullbackStrength: 3.0,
      accelerationTime: 0.15,
      accelerationStrength: 2.0,
      symbolsPerSecond: 18,
      mainReelSpinTime: 0.8,
      mainReelSpinTimeReelOffset: mainReelSpinOffset,
      decelerationTime: 0.3,
      decelerationStrength: 3.0,
      bounceAmount: 20,
      bounceTime: 0.25,
    };
    const mainReelSpinOffsets = mainReelStartOffset + mainReelSpinOffset;

    spinController.mainSpinTimeOffsets[i] = mainReelSpinOffsets;
    spinController.mainSpinConfig[`reel${i}`] = mainReel;
  }

  gameController.slotMachine.holdReels(reelsToHold);
  gameController.slotMachine.dynamicSpin(spinController.mainSpinConfig);
};

spinController.stopSpin = function (symbols, above, below, mainSpinCompleteCallback) {
  // For this game anticipation will happen on all reels after two bonus symbols

  spinController.longSpinMainReels = [false, false, false, false, false];

  spinController.checkForLongSpinReels(symbols);

  spinController.setupLandConfigs();

  gameController.slotMachine.stopReels(symbols, above, below, mainSpinCompleteCallback, spinController.mainLandConfig);
};

spinController.setupLandConfigs = function () {
  let reels = [];

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    if (spinController.longSpinMainReels[i]) {
      reels.push(i);
    }
  }

  const decelTime = 2.8;
  const anticipationInterval = 2.8;

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    let mainReel = {
      type: "main",
      mainReelSpinExtension: 0,
    };
    spinController.mainLandConfig[`reel${i}`] = mainReel;
  }

  for (let i = 0; i < reels.length; i++) {
    const reel = reels[i];
    const mainSpinExtension = i * anticipationInterval;

    let mainReel = {
      type: "main",
      mainReelSpinExtension: mainSpinExtension,
      decelerationTime: decelTime,
      decelerationStrength: 2,
      bounceAmount: 1,
      bounceTime: 0.1,
    };
    spinController.mainLandConfig[`reel${reel}`] = mainReel;
  }
};

spinController.checkForLongSpinReels = function (symbols) {
  if (gameController.isRespinning) {
    for (let i = 0; i < gameController.respunReels.length; i++) {
      const reel = gameController.respunReels[i];
      spinController.longSpinMainReels[reel] = true;
    }
  } else {
    let bonusCount = 0;

    // Main reels
    for (let reel = 0; reel < 5; reel++) {
      for (let row = 0; row < 3; row++) {
        if (bonusCount >= 2) {
          spinController.longSpinMainReels[reel] = true;
        }
        if (reel < 3 || (reel === 3 && bonusCount >= 1)) {
          if (symbols[reel][row] === 17) {
            bonusCount++;
            break;
          }
        }
      }
    }
  }
};
